
import React from 'react';
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader } from "@/components/ui/card";
import { ChevronDown, ChevronUp, ChevronLeft, ChevronRight } from "lucide-react";
import QuestionBankCard from './QuestionBankCard';

const QuestionBankSection = ({
  title,
  questionBanks,
  users,
  uniqueUsers,
  showSection,
  setShowSection,
  onView,
  onDelete,
  convertISOtoLocale,
  isSearching,
  search,
  searchResults = [],
  hideDelete = false,
  currentPage = 1,
  setCurrentPage,
  itemsPerPage = 6
}) => {
  const displayBanks = isSearching && search.length > 0 ? searchResults : questionBanks;
  const noResultsMessage = isSearching && search.length > 0 
    ? `No searched ${title}` 
    : `No ${title} Found`;

  // Calculate pagination
  const totalPages = Math.ceil(displayBanks.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const currentBanks = displayBanks.slice(startIndex, endIndex);

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  return (
    <Card className="mb-6">
      <CardHeader>
        <div className="flex items-center justify-between">
          <p className="text-lg font-semibold text-gray-700">{title}</p>
          <div className="gap-5 flex">
            <Button onClick={() => setShowSection(!showSection)}>
              {showSection ? (
                <ChevronUp className="w-5 h-5" />
              ) : (
                <ChevronDown className="w-5 h-5" />
              )}
            </Button>
          </div>
        </div>
      </CardHeader>
      {showSection && (
        <CardContent>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 w-full">
            {currentBanks.length === 0 ? (
              <div className="flex justify-center xl:w-[1100px]">
                <p>{noResultsMessage}</p>
              </div>
            ) : (
              currentBanks.map((question, index) => (
                <QuestionBankCard
                  key={question._id || index}
                  question={question}
                  index={index}
                  users={users}
                  uniqueUsers={uniqueUsers}
                  onView={onView}
                  onDelete={onDelete}
                  convertISOtoLocale={convertISOtoLocale}
                  hideDelete={hideDelete}
                />
              ))
            )}
          </div>
          
          {/* Pagination */}
          {totalPages > 1 && (
            <div className="flex justify-center items-center mt-6 space-x-2">
              <Button
                variant="outline"
                size="sm"
                onClick={() => handlePageChange(currentPage - 1)}
                disabled={currentPage === 1}
              >
                <ChevronLeft className="w-4 h-4" />
                Previous
              </Button>
              
              <div className="flex space-x-2">
                {[...Array(totalPages)].map((_, i) => {
                  const page = i + 1;
                  return (
                    <Button
                      key={page}
                      variant={currentPage === page ? "default" : "outline"}
                      size="sm"
                      onClick={() => handlePageChange(page)}
                      className="w-8 h-8 p-0"
                    >
                      {page}
                    </Button>
                  );
                })}
              </div>
              
              <Button
                variant="outline"
                size="sm"
                onClick={() => handlePageChange(currentPage + 1)}
                disabled={currentPage === totalPages}
              >
                Next
                <ChevronRight className="w-4 h-4" />
              </Button>
            </div>
          )}
        </CardContent>
      )}
    </Card>
  );
};

export default QuestionBankSection;